
// 小节动作
export type ActionTypeName = 'start' | 'pause' | 'resume' | 'end' | 'close' | 'achieve' | 'playing' | 'init' | 'seek';

export enum SESSION_ACTION_TYPE {
    INIT = 0, // 拉取配置信息
    BEGIN = 1, // 进入页面 || 开始播放
    END = 2, // 完成小节完成动作
    DOING = 3, // 页面浏览中 || 视频播放中 || 关闭页面 || 视频暂停
    RESUME = 11, // 视频继续播放
}

// 是否达到学习时长要求
export enum ACHIEVE_TIME_REQUIRE {
    NOT_ACHIEVE,
    ACHIEVE,
}

export interface IMakeStatusParam {
    status?: SESSION_ACTION_TYPE;
    vlt_status?: ACHIEVE_TIME_REQUIRE;
    sessionId: number;
    action: ActionTypeName;
}

export type ILearningTimeLogParams = {
    sessionId: number,
    groupId: number,
    enterpriseId: string,
    action?: ActionTypeName,
    page?: string,
    currentTime?: number,
} | null | undefined;

export interface ILearningStatusRef {
    achieveTimeStatus: boolean;
    startLog: VoidFunction;
    pauseLog: VoidFunction;
    reStartLog: VoidFunction;
    closePageLog: VoidFunction;
}

export declare class TimeDuration {
    hour: number;
    minute: number;
    second: number;
    format: () => string;

    constructor(time?: {hour: number, minute: number; second: number})
}
